import React, { useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";
import { Parser } from 'html-to-react'
import useMediaQuery from '@mui/material/useMediaQuery';
import ModelContext from "../ModelContext";

export const TechData = (props) => {
    const modelCtx = useContext(ModelContext);
    const [techData, setTechData] = useState("");
    const [isPreliminaryData, setIsPreliminaryData] = useState(false);

    const isTablet = useMediaQuery('(max-width:1024px)');
    const isMobile = useMediaQuery('(max-width:480px)');

    useEffect(() => {
        const getTechData = async () => {
            const input = modelCtx.inputModelData;

            if ((input.idBasicModel !== 0) && (input.idModel !== 0)) {
                let apiUrl = "/api/model/modeldata";
                if (isTablet && !isMobile) {
                    apiUrl = "/api/model/modeldataresponsive";
                }
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    body: JSON.stringify(input),
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.ok) {
                    const data = await response.text(); // return a string
                    if (data) {
                        setTechData(data);
                        const model = modelCtx.modelsData.filter(m => m.idModel === input.idModel);
                        if (model) {
                            setIsPreliminaryData(model[0].preliminaryData);
                        }
                    } else {
                        //props.feedbackCallback("error", "Errore durante la lettura delle informazioni sulla societ�", true);
                    }

                } else {
                    const error = await response.text();
                    //props.feedbackCallback("error", error, true);
                }
            }
        }

        getTechData();
    }, [modelCtx.inputModelData]);


    return (
        <div>

            <div className="row justify-content-center">
                <div className="col-12 bg-blue descriptions">
                    <div className="box">
                        <p className="color-white wow fadeInUp" data-wow-delay="0.4s">
                            <span className="title1">Technical data</span><br /><br />
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <p>&nbsp;</p>
            </div>
            <div className="row justify-content-center">
                <div style={{width: "90%"}}>
                    {Parser().parse(techData)}
                </div>
            </div>
        </div>
    );
};

export default TechData;
